import $ from 'jquery';
import Cache from 'root/cache';
import UI from 'root/ui';
import Modal from 'root/module/modal';
import Modals from 'root/modals';
import Svg_Icon from 'root/module/svg_icon';
import View from 'view/base';
import Model_Widget from 'model/widget';


export default View.extend({
    className: 'project-settings-ai',

    events: {
        'click .setting-toggle'    : 'onToggleSetting',
        'click .widget-settings a' : 'onOpenWidgetSettings',
        'click .account-upgrade'   : 'onUpgradeAccount'
    },

    dom_handlers: {
        onToggleSetting: function (e) {
            if (!Cache.app.isAdmin()) {
                Modal.open({
                    title: 'Admin required',
                    content: '<p>You\'ll need to ask an account admin to enable this option.</p>',
                    button: {
                        OK: () => {
                            Modal.close();
                        }
                    }
                });
                return;
            }

            var project = Cache.getDefaultProject();
            var widget  = Cache.widget.findWhere({ project_id: project.id });

            var target = $(e.currentTarget);
            var setting = target.data('val');
            var is_on = target.hasClass('switch-off');

            if (is_on) {
                target.removeClass('switch-off').addClass('switch-on');
            } else {
                target.removeClass('switch-on').addClass('switch-off');
            }

            if (setting === 'ai_feedback_type') {
                // widget setting
                widget.set(setting, is_on);

                this.$el.find('.widget-settings').toggle(!widget.get('ai_feedback_type'));

                Cache.app.request({
                    action: 'widget/toggleAI',
                    data: {
                        widget_id: widget.id,
                        [setting]: is_on
                    },
                    success: () => {
                        if (setting === 'ai_feedback_type') {
                            UI.success('Feedback type turned ' + (is_on ? 'on' : 'off'));
                        }
                    }
                });
            } else {
                // project setting
                project.set(setting, is_on);

                Cache.app.request({
                    action: 'project/update',
                    data: {
                        project_id: project.id,
                        [setting]: is_on
                    },
                    success: () => {
                        if (setting === 'ai_feedback_sentiment') {
                            UI.success('User Sentiment turned ' + (is_on ? 'on' : 'off'));
                        } else if (setting === 'ai_feedback_action') {
                            UI.success('Awaiting Response turned ' + (is_on ? 'on' : 'off'));
                        } else if (setting === 'ai_feedback_title') {
                            UI.success('Feedback Title turned ' + (is_on ? 'on' : 'off'));
                        }
                    }
                });
            }
        },

        onOpenWidgetSettings: function (e) {
            e.preventDefault();

            Modals.openWidgetStudio(null, false, null, '#feedback');
        },

        onUpgradeAccount: function () {
            Modals.choosePlan();
        }
    },

    initialize: function() {
        this.widget = Cache.widget.findWhere({ project_id: this.model.id });
    },

    loadWidget: function() {
        Cache.app.request({
            action: 'widget/load',
            data: {
                project_id: this.model.id
            },
            success: (response) => {
                this.widget = new Model_Widget(response[0]);
                this.render();
            }
        });
    },

    render: function() {
        var content = '';

        if (!this.widget) {
            content +=
            '<div class="project-settings-inner-large form-fluid">' +
                '<div class="loader-placeholder margin-bottom-12"></div>' +
                '<div class="loader-placeholder margin-bottom-12"></div>' +
                '<div class="loader-placeholder"></div>' +
            '</div>';
        } else {
            content +=
            '<div class="project-settings-inner-large form-fluid">' +
                '<div>' +
                    (this.widget.isNextGen() ?
                    '<div class="field-label">Feedback Type</div>' +
                    '<div class="box-small-medium">' +
                        '<div class="grid-10-2">' +
                            '<div>' +
                                '<p>Leverage AI to automatically classify user feedback as a bug, idea, or general feedback.</p>' +
                            '</div>' +
                            '<div class="text-align-right">' +
                                '<button class="setting-toggle setting-toggle-widget small ' + (this.widget.get('ai_feedback_type') ? 'switch-on' : 'switch-off') + '" data-val="ai_feedback_type"></button>' +
                            '</div>' +
                        '</div>' +
                        '<div class="flex-between margin-top-12">' +
                            '<div class="feedback-type-icons">' +
                                '<div>Bug</div>' +
                                '<div>Idea</div>' +
                                '<div>General</div>' +
                            '</div>' +
                            '<div class="widget-settings"><a href="#" class="primary font-weight-medium"><i class="fa-solid fa-cog"></i> Configure without AI</a></div>' +
                        '</div>' +
                    '</div>' : '') +

                    '<div class="divider-12"></div>' +

                    '<div class="field-label">Feedback Title</div>' +
                    '<div class="box-small-medium grid-10-2">' +
                        '<div>' +
                            '<p>Leverage AI to automatically generate feedback titles from description provided by the user.</p>' +
                        '</div>' +
                        '<div class="text-align-right">' +
                            '<button class="setting-toggle setting-toggle-project small ' + (this.model.get('ai_feedback_title') ? 'switch-on' : 'switch-off') + '" data-val="ai_feedback_title"></button>' +
                        '</div>' +
                    '</div>' +

                    '<div class="divider-12"></div>' +

                    '<div class="field-label">User Sentiment</div>' +
                    '<div class="box-small-medium grid-10-2">' +
                        '<div>' +
                            '<p>Leverage AI to assess user sentiment automatically, providing insights for more effective responses.</p>' +
                            '<div class="sentiment-icons margin-top-12">' +
                                '<div class="tooltip" data-title="User sentiment: Negative">' + Svg_Icon.face_hate + '</div>' +
                                '<div class="tooltip" data-title="User sentiment: Neutral">' + Svg_Icon.face_neutral + '</div>' +
                                '<div class="tooltip" data-title="User sentiment: Positive">' + Svg_Icon.face_love + '</div>' +
                            '</div>' +
                        '</div>' +
                        '<div class="text-align-right">' +
                            '<button class="setting-toggle setting-toggle-project small ' + (this.model.get('ai_feedback_sentiment') ? 'switch-on' : 'switch-off') + '" data-val="ai_feedback_sentiment"></button>' +
                        '</div>' +
                    '</div>' +

                    '<div class="divider-12"></div>' +

                    '<div class="field-label">Awaiting Response</div>' +
                    '<div class="box-small-medium grid-10-2">' +
                        '<div>' +
                            '<p>Leverage AI to automatically analyze user feedback and determine whether the user is expecting a response, helping you promptly prioritize issues.</p>' +
                        '</div>' +
                        '<div class="text-align-right">' +
                            '<button class="setting-toggle setting-toggle-project small ' + (this.model.get('ai_feedback_action') ? 'switch-on' : 'switch-off') + '" data-val="ai_feedback_action"></button>' +
                        '</div>' +
                    '</div>' +

                    (Cache.account.hasFeature('ai') ? '' :

                    (Cache.account.get('appsumo') ?
                    '<div class="text-align-center margin-top-32">' +
                        '<button type="button" class="shiny medium cursor-default"><span>Add-on coming soon</span></button>' +
                    '</div>'

                    :

                    '<div class="text-align-center margin-top-32">' +
                        '<button type="button" class="account-upgrade shiny medium"><span>Upgrade my plan</span></button>' +
                    '</div>')

                    ) +
                '</div>' +
            '</div>';
        }

        this.$el.html(content);

        if (this.widget && this.widget.get('ai_feedback_type')) {
            this.$el.find('.widget-settings').hide();
        }

        if (this.widget && !Cache.account.hasFeature('ai')) {
            this.$el.find('.setting-toggle').prop('disabled', true);
        }

        if (!this.widget) {
            this.loadWidget();
        }

        return this;
    }
});